import { render, staticRenderFns } from "./marketingSMSTemplate.vue?vue&type=template&id=4ea23a44&scoped=true&"
import script from "./marketingSMSTemplate.vue?vue&type=script&lang=js&"
export * from "./marketingSMSTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea23a44",
  null
  
)

component.options.__file = "marketingSMSTemplate.vue"
export default component.exports